import styled from 'styled-components';

export const AppContainer = styled.div`
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    display: flex;
    overflow: auto;
`;
